export default "__VITE_ASSET__D236PcoV__"